<template>
  <div>
    <ts-dialog
      :title="`Move your ${projects.length > 1 ? projects.length : ''} project${
        projects.length > 1 ? 's' : ''
      } to another folder`"
      :visible.sync="visible"
      width="600px"
      center
    >
      <div class="mb-2">
        <ts-form-item label="Select a folder" class="mb-4" :validation="$v.folder">
          <MultiSelectionDropdown
            placeholder="Destination path"
            :max-items="1"
            :options="folders"
            :read-only-single-option="false"
            v-model.lazy="destinations"
          ></MultiSelectionDropdown>
        </ts-form-item>
      </div>
      <div slot="footer" class="flex items-end justify-center">
        <div class="font-semibold">
          <ts-button class="font-semibold" :loading="loading" title="Close" @click="moveProjects"
            >Move projects</ts-button
          >
        </div>
      </div>
    </ts-dialog>
  </div>
</template>

<script>
import appSettingsProvider from '@/appsettings';
import MultiSelectionDropdown from '@/components/inputs/MultiSelectionDropdown.vue';
import { required } from 'vuelidate/lib/validators';
import { mapState, mapActions } from 'vuex';
import projectViewHelpers from '@/mixins/projectViewHelpers';

export default {
  mixins: [projectViewHelpers],
  components: { MultiSelectionDropdown },
  data() {
    return {
      loading: false,
      visible: false,
      projects: [],
      folder: null,
      callback: null,
      destinations: [],
      form: {
        email: '',
        message: ''
      }
    };
  },
  computed: {
    ...mapState('workflow', {
      baseFolders: state => state.myProjects.items
    }),
    folders() {
      return this.baseFolders.filter(f => f.user_id === this.currentUser.id);
    },
    sharing() {
      return this.project.sharings.find(s => s.resource === 'delivery');
    },
    url() {
      return `${this.appUrl}/projects/sharings/${this.sharing?.token}`;
    }
  },
  validations: {
    folder: {
      required
    }
  },
  methods: {
    ...mapActions('workflow', ['updateProjectFolder']),
    async moveProjects() {
      this.folder = this.destinations[0] || null;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        try {
          this.loading = true;
          for (let project of this.projects) {
            await this.updateProjectFolder({
              project,
              value: this.folder
            });
          }
          this.loading = false;
          if (this.callback) {
            this.callback(true);
          }
          this.skip();
        } catch (error) {
          console.error(error);
          this.loading = false;
        }
      }
    },
    handleOpenDialogButtonClick(callback) {
      this.callback = null;
      this.visible = true;
      this.callback = callback;
    },
    resetForm() {
      this.projects = [];
    },
    skip() {
      this.visible = false;
      this.resetForm();
    },
    handleSaveClick() {}
  },
  mounted() {
    window.EventBus.$on('folders.move', ({ projects, done }) => {
      this.projects = [];
      this.projects = projects || [];
      this.handleOpenDialogButtonClick(done);
    });
  }
};
</script>

<style lang="scss" scoped>
.text-xl {
  font-size: 1.3rem;
}
.text-center {
  text-align: center;
}
.items-end {
  align-items: flex-end;
}
.row {
  background: #ebecf0;
  background-image: linear-gradient(-42deg, rgba(0, 0, 0, 0.4) 0%, rgba(255, 255, 255, 0.4) 100%);
  background-blend-mode: soft-light, normal;
  background-clip: padding-box;
  border: 2px solid rgba(255, 255, 255, 0.16);
  box-shadow: -2px -2px 6px 0 rgba(250, 251, 255, 0.48), 2px 2px 6px 0 rgba(166, 171, 189, 0.24);
  border-radius: 16px;
  margin-bottom: 10px;

  display: flex;
  align-items: center;
  padding: 22px 18px;

  .checkbox {
    margin-right: 13px;
  }

  .file-info {
    width: 400px;
  }

  .file-name {
    font-family: Roboto;
    font-size: 16px;
    color: #6d7587;
  }

  .file-creation-info {
    font-family: Roboto;
    font-size: 10px;
    line-height: 16px;
    color: #acbacc;
  }

  .files {
    flex-grow: 1;
  }

  .actions {
    display: flex;
    align-items: center;

    > * {
      margin-left: 10px;
    }
  }
}
.flex {
  display: flex;
}
.justify-center {
  justify-content: center;
}
.items-center {
  align-items: center;
}
.mb-2 {
  margin-bottom: 0.5em;
}
.flex-1 {
  flex: auto;
}
.flex-none {
  flex: none;
}
.px-2 {
  padding-left: 0.5em;
  padding-right: 0.5em;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.py-2 {
  padding-top: 0.5em;
  padding-bottom: 0.5em;
}
.justify-between {
  justify-content: space-between;
}
.cursor-pointer {
  cursor: pointer;
}
.mr-4 {
  margin-right: 1rem;
}
</style>